import { Link } from '@remix-run/react'
import beth from './about-us+/beth353x326.png'
import daren from './about-us+/daren353x326.png'
import matt from './about-us+/mathieu353x326.jpg'
import dan from './dan353x326.jpg'
import joel from './joel353x326.jpg'

export default function Component() {
	return (
		<main className="mx-auto my-10 max-w-7xl">
			<Link to="/" prefetch="intent" className="text-blue-600 underline">
				Home
			</Link>

			<h1 className="py-3 text-4xl font-black">Set an appointment</h1>

			<div className="grid grid-cols-1 gap-4 md:grid-cols-3">
				<div>
					<a
						href="https://calendly.com/darenforrest"
						target="_blank"
						rel="noopener noreferrer"
						className="text-blue-600 underline"
					>
						<span className="image">
							<img
								src={daren}
								alt="Daren Forrest"
								className="max-w-xs rounded-lg"
							/>
						</span>
						<br />
						schedule with Daren (opens in a new tab)
					</a>
				</div>
				<div>
					<a
						href="https://calendly.com/joel-steele"
						target="_blank"
						rel="noopener noreferrer"
						className="text-blue-600 underline"
					>
						<span className="image">
							<img
								src={joel}
								alt="Joel Steele"
								className="max-w-xs rounded-lg"
							/>
						</span>
						<br />
						schedule with Joel (opens in a new tab)
					</a>
				</div>

				<div>
					<a
						href="https://calendly.com/mathieu-steele"
						target="_blank"
						rel="noopener noreferrer"
						className="text-blue-600 underline"
					>
						<span className="image">
							<img
								src={matt}
								alt="Matt Steele"
								className="max-w-xs rounded-lg"
							/>
						</span>
						<br />
						schedule with Matt (opens in a new tab)
					</a>
				</div>

				<div>
					<a
						href="https://calendly.com/beth-ficarro"
						target="_blank"
						rel="noopener noreferrer"
						className="text-blue-600 underline"
					>
						<span className="image">
							<img
								src={beth}
								alt="Beth Ficarro"
								className="max-w-xs rounded-lg"
							/>
						</span>
						<br />
						schedule with Beth (opens in a new tab)
					</a>
				</div>

				<div>
					<a
						href="https://calendly.com/daniel-miles"
						target="_blank"
						rel="noopener noreferrer"
						className="text-blue-600 underline"
					>
						<span className="image">
							<img
								src={dan}
								alt="Daniel Miles"
								className="max-w-xs rounded-lg"
							/>
						</span>
						<br />
						schedule with Dan (opens in a new tab)
					</a>
				</div>
			</div>
		</main>
	)
}
